import styled, { css } from 'styled-components/macro'

import { settings } from '../../styled/settings/index';
import { mixins } from '../../styled/mixins/index';

const {
  colors: { color, hexToRGBa },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletPortraitDown, tabletLandscapeUp },
  sizing: { fontsize, spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  layout: { centered, centeredContent, pageSection, pageSectionInner },
  typography: { heading1, heading2, heading3, heroDescription },
} = mixins;

export const AccountabilityContainer = styled.section`
  ${pageSection}
  background-color: ${color(`white`)};

  h1 {
    ${heading1}
  }

  h2 {
    ${heading2}
  }

  h3 {
    ${heading3}
  }

  p {
    ${heroDescription}
  }

  img {
    max-width: 100%;
  }

  .Button {
    margin: 0 auto;
    display: table;

    &:hover {
      background: ${color(`white`)} !important;
      border: solid 1px ${color(`black`)};
      color: ${color(`black`)};
    }

    &:focus {
      background: ${color(`black`)} !important;
    }

    &[disabled] {
      opacity: 0.4;
      pointer-events: none;
      cursor: progress;
    }

    &.hide {
      display: none;
    }
  }

  .center {
    margin: 0 auto;
    display: table;
  }
`;

export const AccountabilityInnerContainer = styled.div`
  ${pageSectionInner}
`;

export const SignatureContainer = styled.div`
  ${pageSectionInner}
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export const Signature = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right: ${spacingsize(7)};

  div {
    display: flex;
    align-items: center;
  }
`;

export const SignatureImage = styled.img`
  justify-content: flex-end;
  border-radius: 50%;
  height: 125px;
  width: 125px;
  display: inline-block;

  @media ${mobileDown} {
    width: 75px;
    height: 75px;
  }
`;

export const InformationContainer = styled.div`

`;

export const ApplyNowButtonContainer = styled.div`
  a {
    margin: 0 auto;
  }
`;

export const ApplyNowButton = styled.button`

`;